package app.nestbridge.feature.children.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class CreateChildProfileScreen(
    val showQrCodeScanButton: Boolean = false,
) : Screen

@Parcelize
data class CreateChildProfileResult(
    val status: Status,
) : PopResult {
    enum class Status { Created, Cancelled }
}

data class CreateChildProfileState(
    val fullName: String,
    val displayName: String,
    val dateOfBirth: String,
    val isSaving: Boolean,
    val errorMessage: String?,
    val onBoardingMode: Boolean = false,
    val eventSink: (CreateChildProfileEvent) -> Unit,
) : CircuitUiState

sealed interface CreateChildProfileEvent {
    data object Back : CreateChildProfileEvent
    data object Continue : CreateChildProfileEvent
    data object ScanQRCode : CreateChildProfileEvent
    data class UpdateFullName(val value: String) : CreateChildProfileEvent
    data class UpdateDisplayName(val value: String) : CreateChildProfileEvent
    data class UpdateDateOfBirth(val value: String) : CreateChildProfileEvent
}

fun CreateChildProfileState.canContinue(): Boolean =
    fullName.isNotBlank() && !isSaving
